<router-outlet></router-outlet>
<app-toast [toast]="errorToast()" (dismissed)="clearErrorToast()" />
@if (workspaceLoading()) {
  <app-loader variant="fullscreen" message="Checking access and preparing workspace..." />
}